import { render, staticRenderFns } from "./wtMapAsset.vue?vue&type=template&id=61fc94c4&"
import script from "./wtMapAsset.vue?vue&type=script&lang=js&"
export * from "./wtMapAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports